import React, { Component } from 'react';
import './index.scss';
import Slick from 'react-slick'

class BannerSection extends Component {

    slickRef
    slickChangeTime = Date.now() + 5000

    interval
    slickAnimationInterval = () => {
        if (this.slickRef) {
            const now = Date.now()
            if (now - this.slickChangeTime >= (10000 + Math.floor(Math.random() * 10000)) && this.slickRef) {
                this.slickRef.slickNext()
                this.slickChangeTime = now
            }
        }
    }

    componentDidMount() {
        setTimeout(() => {
            this.interval = setInterval(this.slickAnimationInterval, 100)
        }, 2000)
    }

    componentWillUnmount() {
        clearInterval(this.interval)
    }

    handleClickPrvBtn = e => {
        e.stopPropagation()
        this.slickRef.slickPrev()
    }

    handleClickNextBtn = e => {
        e.stopPropagation()
        this.slickRef.slickNext()
    }

    handelClickBanner = (banner) => {
        switch (banner) {
            case 'flitto':
                window.open('https://heavenly-bull-19f.notion.site/Flitto-068decefcc8c4152b2d44532388c6159')
                break

            case 'cos247':
                window.open('https://www.cos-247.com/')
                break
                
            default:
                break
        }
    }

    renderLeftSection = () => {
        const { value } = this.props

        let src = ''
        let onClick

        switch (value) {
            case 'ko':
                src = 'https://front.videomonster.com/images-u6yd72dy/web/main/banner/k-voucher-banner.png'
                onClick = () => window.open('https://www.k-voucher.kr/index.php/page/productSearch?mode=update&seq=913')
                break

            case 'jp':
                src = 'https://front.videomonster.com/images-u6yd72dy/web/main/banner/gettyImageBanner_JP.jpg'
                break

            default:
                src = 'https://front.videomonster.com/images-u6yd72dy/web/main/banner/gettyImageBanner_EN.jpg'
                break
        }

        return (
            <div><img src={src} onClick={onClick} style={{ cursor: onClick ? 'pointer' : 'default' }} alt='' /></div>
        )
    }

    renderRightSection = () => {
        const { value } = this.props

        let src = ''
        let onClick = () => {
            this.props.history.push('/payment')
        }

        switch (value) {
            case 'ko':
                src = 'https://front.videomonster.com/images-u6yd72dy/web/main/banner/premium-payment.png'
                break

            case 'jp':
                src = 'https://front.videomonster.com/images-u6yd72dy/web/main/banner/pointshopEventBanner_jp.jpg'
                break

            default:
                src = 'https://front.videomonster.com/images-u6yd72dy/web/main/banner/pointshopEventBanner_en.jpg'
                break
        }

        return (
            <div>
                <img src={src} onClick={onClick} style={{ cursor: onClick ? 'pointer' : 'default' }} alt='' />
            </div>
        )
    }

    render() {
        const { value } = this.props
        const settings = {
            className: 'slider',
            infinite: true,
            speed: 200,
            slidesToShow: 4,
            slidesToScroll: 1,
        }
        return (
            <div className="banner-section-root-container">
                <div className='title'>{value === 'ko' ? '비디오몬스터' : 'VideoMonster'}</div>
                <div className='subtitle'>For Business</div>
                <div className="banner-wrap">
                    <div className="banner-relative-wrap">
                        <Slick {...settings} ref={ref => this.slickRef = ref}>
                            <div className='slider-item'>{this.renderLeftSection()}</div>
                            <div className='slider-item'>{this.renderRightSection()}</div>
                            <div className='slider-item'>
                                <div><img src='https://front.videomonster.com/images-u6yd72dy/web/main/banner/flitto-banner.png' onClick={() => this.handelClickBanner('flitto')} style={{ cursor: 'pointer' }} alt="" /></div>
                            </div>
                            <div className='slider-item'>
                                <div><img src='https://front.videomonster.com/images-u6yd72dy/web/main/banner/cos247-banner.jpg' onClick={() => this.handelClickBanner('cos247')} style={{ cursor: 'pointer' }} alt="" /></div>
                            </div>
                        </Slick>
                        {/* 배너가 4개 이상일 경우 < > 화살표 활성화 */}
                        {/* <div className='slider-btn' >
                            <img src='https://front.videomonster.com/images-u6yd72dy/web/home/banner-section-arrow-left.svg' onClick={this.handleClickPrvBtn} alt='prev btn' />
                            <img src='https://front.videomonster.com/images-u6yd72dy/web/home/banner-section-arrow-right.svg' onClick={this.handleClickNextBtn} alt='next btn' />
                        </div> */}
                    </div>
                </div>
            </div>
        );
    }
}

export default BannerSection